import { ref, onMounted } from 'vue'
import { setAuthToken, getAuthToken, clearAuthToken } from '@/services/api'

export function useAuth() {
  const token = ref<string | null>(null)
  const isAuthenticated = ref(false)
  const authError = ref<string | null>(null)

  // Extrai o token da URL (query parameter)
  const extractTokenFromUrl = (): string | null => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('token')
  }

  // Inicializa a autenticação
  const initAuth = () => {
    // Primeiro tenta extrair da URL
    const urlToken = extractTokenFromUrl()

    if (urlToken) {
      token.value = urlToken
      setAuthToken(urlToken)
      isAuthenticated.value = true
      authError.value = null

      // Remove o token da URL por segurança (sem recarregar a página)
      const url = new URL(window.location.href)
      url.searchParams.delete('token')
      window.history.replaceState({}, document.title, url.toString())
    } else {
      // Verifica se já tem um token armazenado
      const storedToken = getAuthToken()
      if (storedToken) {
        token.value = storedToken
        isAuthenticated.value = true
        authError.value = null
      } else {
        isAuthenticated.value = false
        authError.value = 'Token de autenticação não fornecido. Acesse esta página através do App Sygecom.'
      }
    }
  }

  // Define um novo token
  const setToken = (newToken: string) => {
    token.value = newToken
    setAuthToken(newToken)
    isAuthenticated.value = true
    authError.value = null
  }

  // Limpa a autenticação
  const logout = () => {
    token.value = null
    clearAuthToken()
    isAuthenticated.value = false
  }

  // Inicializa automaticamente ao montar
  onMounted(() => {
    initAuth()
  })

  return {
    token,
    isAuthenticated,
    authError,
    initAuth,
    setToken,
    logout
  }
}
